"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f106 = void 0;
exports.f106 = {
    "jugari": [
        39,
        531
    ],
    "jivaro": [
        79,
        3376
    ],
    "jopadhola": [
        93
    ],
    "jandali": [
        104
    ],
    "jiamu": [
        201
    ],
    "jiamuhua": [
        201
    ],
    "jin": [
        201,
        598,
        1494,
        1495
    ],
    "jinhua": [
        201,
        1494,
        1495
    ],
    "jewish": [
        3416,
        7605,
        204,
        863,
        3341,
        3342,
        3343,
        8791,
        8922,
        7706
    ],
    "jbeli": [
        204
    ],
    "japan": [
        208,
        209,
        303,
        2071,
        3302,
        3303,
        3304,
        3385,
        3425,
        4168,
        5159,
        5864,
        5883,
        6646,
        6647,
        6648,
        7544,
        8674,
        8875,
        8881
    ],
    "jp": [
        208,
        209,
        303,
        2071,
        3302,
        3303,
        3304,
        3385,
        3425,
        4168,
        5159,
        5864,
        5883,
        6646,
        6647,
        6648,
        7544,
        8674,
        8875,
        8881
    ],
    "jo": [
        281,
        3415,
        4554,
        5809,
        7485,
        224,
        416,
        436,
        3414,
        5829
    ],
    "jordan": [
        224,
        416,
        436,
        3414,
        5829
    ],
    "judeo-tunisian": [
        225,
        226
    ],
    "judeo-tunisian arabic": [
        225,
        226
    ],
    "judeo-moroccan": [
        227,
        3421
    ],
    "judeo-moroccan arabic": [
        227
    ],
    "jero": [
        241,
        3345
    ],
    "jeru": [
        241,
        2510
    ],
    "jo alur": [
        281
    ],
    "jaintia": [
        296
    ],
    "jñom’ndaa": [
        305
    ],
    "jarawa": [
        331,
        332,
        3358,
        3379,
        627,
        3300
    ],
    "jarawa (india)": [
        331,
        332
    ],
    "jambo": [
        337,
        338
    ],
    "jicarilla": [
        378
    ],
    "jicarilla abáachi": [
        378
    ],
    "jicarilla apache": [
        378
    ],
    "jiparaná": [
        2835,
        450,
        7120
    ],
    "jenimu": [
        558,
        564
    ],
    "jair": [
        561,
        8807
    ],
    "jair awyu": [
        561
    ],
    "jarionga": [
        566
    ],
    "jaroinga": [
        566
    ],
    "jurangka": [
        566
    ],
    "jabuda": [
        576,
        3482
    ],
    "jovai": [
        584
    ],
    "jin phula": [
        598
    ],
    "jnꞌoon": [
        603
    ],
    "jñon’ndaa": [
        603
    ],
    "jñunda": [
        604
    ],
    "jar": [
        627,
        3358
    ],
    "jarawan kogi": [
        627
    ],
    "jarawan": [
        627,
        3300,
        3358,
        3379
    ],
    "jola bayote": [
        685
    ],
    "jola": [
        685,
        2038,
        2039
    ],
    "jhaliya": [
        706
    ],
    "jharia": [
        706
    ],
    "jhodia parja": [
        706
    ],
    "jhodia": [
        706
    ],
    "jaba": [
        3306,
        719,
        4253
    ],
    "jati": [
        3320,
        721,
        6725
    ],
    "jakarta malay": [
        736
    ],
    "jakarta": [
        736
    ],
    "jakarte": [
        736
    ],
    "jur modo": [
        737,
        738
    ],
    "jur": [
        737,
        738,
        923,
        4554
    ],
    "jur mödö": [
        737,
        738
    ],
    "jatu": [
        781,
        3320
    ],
    "jangan": [
        786
    ],
    "jaisi": [
        800
    ],
    "jamu": [
        809,
        810
    ],
    "judeo-tajik": [
        814,
        815,
        816
    ],
    "jur beli": [
        923
    ],
    "jinping dai": [
        933,
        934,
        935
    ],
    "jinping": [
        933,
        934,
        935,
        7825,
        7826
    ],
    "japanese pidgin english": [
        1035
    ],
    "japanese": [
        3302,
        3303,
        3304,
        3425,
        5864,
        1035
    ],
    "jóola banjal": [
        1059
    ],
    "jóola": [
        1640,
        1059,
        2038,
        2039
    ],
    "jokay": [
        1093,
        1094
    ],
    "jilama bawang": [
        1117,
        1143
    ],
    "jilama": [
        1117,
        1143
    ],
    "jilama sungai": [
        1117,
        1143
    ],
    "janena": [
        1129
    ],
    "janera": [
        1129
    ],
    "jikai": [
        1213
    ],
    "jalkunan": [
        1258
    ],
    "jalkuna": [
        1258
    ],
    "jenaama": [
        1300,
        1301
    ],
    "jenaama bozo": [
        1300,
        1301
    ],
    "jenama": [
        1300,
        1301
    ],
    "jaborlang": [
        1303
    ],
    "juipera": [
        1314
    ],
    "jorge": [
        1355
    ],
    "juni kuin": [
        1365
    ],
    "juni": [
        1365
    ],
    "jama": [
        1375,
        6896
    ],
    "jmíiˊ": [
        1380
    ],
    "juu jmiih": [
        1454,
        1380
    ],
    "juu": [
        1454,
        1380,
        4023
    ],
    "jmiih": [
        1454,
        1444,
        1584,
        1629,
        1644,
        1682,
        1380
    ],
    "jone": [
        1386
    ],
    "jeywo": [
        1411
    ],
    "jaabɛ": [
        1423
    ],
    "jalaa": [
        1423
    ],
    "jalabɛ": [
        1423
    ],
    "jagatai": [
        1442
    ],
    "jmiih kia’ dzä ‘vï ï": [
        1444
    ],
    "jujmi": [
        1548,
        1444,
        1660
    ],
    "jargon": [
        1449,
        1450
    ],
    "jumi dsa mojai": [
        1461
    ],
    "jumi": [
        1461
    ],
    "juujmii": [
        1461
    ],
    "jinyu": [
        1494,
        1495
    ],
    "jin chinese": [
        1494,
        1495
    ],
    "jinese": [
        1494,
        1495
    ],
    "jinyu chinese": [
        1494,
        1495
    ],
    "jezik": [
        1501,
        1647,
        6939,
        6940,
        7220,
        8906
    ],
    "juan": [
        4819,
        6251,
        8653,
        1516,
        1548,
        4590,
        4815,
        4817,
        7432,
        7702,
        8125,
        8656,
        8970,
        8986,
        9003,
        9122,
        9129,
        9132,
        9160
    ],
    "jna’a": [
        1656,
        1669,
        1710,
        1528,
        1676,
        1716
    ],
    "jas": [
        1554
    ],
    "jajmi dzä kï ï’": [
        1555,
        1702
    ],
    "jajmi": [
        1555,
        1702
    ],
    "jejmei": [
        1555,
        1702
    ],
    "jejmi": [
        1555,
        1702
    ],
    "joaquín": [
        1568
    ],
    "javier": [
        1568
    ],
    "jajme dzä mii": [
        1584,
        1629
    ],
    "jajme": [
        1584,
        1629
    ],
    "jmiih kia’ dzä mii": [
        1584,
        1629
    ],
    "james": [
        1608,
        1609,
        1612,
        1613
    ],
    "james bay cree southern dialect": [
        1608,
        1609
    ],
    "james bay cree": [
        1612,
        1613
    ],
    "james bay cree northern": [
        1612,
        1613
    ],
    "jazyk": [
        1627,
        1628,
        1633,
        3937,
        3938,
        5896,
        6910,
        6911,
        8398,
        8399
    ],
    "jãzëk": [
        1630
    ],
    "jola-kasa": [
        1640
    ],
    "jóola kaasa": [
        1640
    ],
    "jóola-kasa": [
        1640
    ],
    "jaú jm_": [
        1644,
        1682
    ],
    "jaú": [
        1644,
        1682
    ],
    "jm": [
        1644,
        1682,
        2168,
        3315,
        3336,
        3388
    ],
    "jmiih kia’ dzä jii’": [
        1644,
        1682
    ],
    "jii’": [
        1644,
        1682
    ],
    "jau jmai": [
        1665
    ],
    "jau": [
        1665
    ],
    "jmai": [
        1665
    ],
    "jaru": [
        1776,
        4231,
        6038
    ],
    "jaroo": [
        1776
    ],
    "jimochaya": [
        1808,
        1809
    ],
    "jula": [
        2040,
        2041,
        2042,
        1816,
        3411,
        3429,
        3606,
        3621
    ],
    "jari": [
        1816,
        3300
    ],
    "johode": [
        1819
    ],
    "jamul diegueño": [
        1851
    ],
    "jamul": [
        1851
    ],
    "jamul tiipay": [
        1851
    ],
    "jaara": [
        1868
    ],
    "jaja-wurrung": [
        1868
    ],
    "jajawurung": [
        1868
    ],
    "jaminjung": [
        1871
    ],
    "jangun djanggun": [
        1875
    ],
    "jangun": [
        1875
    ],
    "jandijinung": [
        1876
    ],
    "jamsay": [
        1880
    ],
    "jamsay dogon": [
        1880
    ],
    "jawan": [
        1881
    ],
    "jawony": [
        1881
    ],
    "jawoyn": [
        1881
    ],
    "jangkang": [
        1882
    ],
    "jambapuing": [
        1883
    ],
    "jambapuingo": [
        1883
    ],
    "jawi": [
        1885,
        4707,
        4708
    ],
    "jammu": [
        1936,
        1937,
        1938
    ],
    "jabirr-jabirr": [
        2032
    ],
    "jabirrjabirr": [
        2032
    ],
    "jugun": [
        2033
    ],
    "jukun": [
        3334,
        2033,
        3427,
        3432,
        3436,
        3442
    ],
    "jinmiire": [
        2035
    ],
    "jinmini": [
        2035
    ],
    "jola-fonyi": [
        2038,
        2039
    ],
    "joola": [
        2038,
        2039
    ],
    "jola-fogny": [
        2038,
        2039
    ],
    "joola-fogny": [
        2038,
        2039
    ],
    "jóola fóoñi": [
        2038,
        2039
    ],
    "julakan": [
        2040,
        2041,
        2042
    ],
    "jula kong": [
        2040,
        2041,
        2042
    ],
    "jaabugay": [
        2043
    ],
    "jonkha": [
        2044
    ],
    "jivali": [
        2046
    ],
    "jiwali": [
        2046,
        4691
    ],
    "jiwarli": [
        2046,
        4691
    ],
    "jola-felupe": [
        2076
    ],
    "jimi": [
        3393,
        3371,
        8750,
        2105,
        6458
    ],
    "język angielski": [
        2118,
        2134,
        2146,
        2210
    ],
    "język": [
        2118,
        2134,
        2146,
        2210,
        6318
    ],
    "je": [
        3348,
        2167,
        5667
    ],
    "jersey": [
        5667,
        2167
    ],
    "jamaica": [
        3388,
        2168,
        3315,
        3336
    ],
    "jiarong": [
        3449,
        2251,
        3373
    ],
    "jaunde": [
        2323
    ],
    "jeeri": [
        2352,
        2365
    ],
    "jalon": [
        2483,
        2484,
        2485
    ],
    "jallon": [
        2483,
        2484,
        2485
    ],
    "jiangxi": [
        2523,
        2524,
        2525
    ],
    "jiangxi hua": [
        2523,
        2524,
        2525
    ],
    "jiangxinese": [
        2523,
        2524,
        2525
    ],
    "jakula": [
        2566
    ],
    "jogula": [
        2566
    ],
    "jokal": [
        2566
    ],
    "jokala": [
        2566
    ],
    "jokul": [
        2566,
        8788
    ],
    "jokula": [
        2566
    ],
    "jugul": [
        2566
    ],
    "jugula": [
        2566
    ],
    "jugulda": [
        2566
    ],
    "jungulda": [
        2566
    ],
    "jibu": [
        3363,
        2592
    ],
    "jeme": [
        2608,
        5817
    ],
    "jega": [
        2639
    ],
    "juchen": [
        2677
    ],
    "jive": [
        2809
    ],
    "jivi": [
        2809
    ],
    "jiwi": [
        2809
    ],
    "jiw": [
        2816
    ],
    "jaíka": [
        2821
    ],
    "jibito": [
        2938
    ],
    "jaia": [
        2965
    ],
    "jia": [
        2981
    ],
    "jagar": [
        3019,
        3020,
        3021,
        3022,
        3023,
        7981,
        7982,
        7983
    ],
    "jiao miao": [
        3050
    ],
    "jiao": [
        3050
    ],
    "jiaojiao miao": [
        3050
    ],
    "jiaojiao": [
        3050
    ],
    "jelnyelv": [
        3059
    ],
    "jabali": [
        3094
    ],
    "jaku iban": [
        3115
    ],
    "jaku": [
        3115,
        3386
    ],
    "jiwadja": [
        3117
    ],
    "jungle": [
        3218,
        7061
    ],
    "jungle inga": [
        3218
    ],
    "jate": [
        3222
    ],
    "judeo-italian": [
        3269
    ],
    "judaico-romanesco": [
        3269
    ],
    "judeo-venetian": [
        3269
    ],
    "jekri": [
        3274
    ],
    "jarawan dutse": [
        3300
    ],
    "jos-zarazon": [
        3300
    ],
    "jamamadí": [
        3305
    ],
    "jabba": [
        3306
    ],
    "jeba": [
        3306
    ],
    "jakalteko": [
        3307
    ],
    "jabxubal": [
        3307
    ],
    "jabʼ xubʼal": [
        3307
    ],
    "jabʼ": [
        3307
    ],
    "jakalteko del oeste": [
        3307
    ],
    "jakalteko-popti’": [
        3307
    ],
    "jahanka": [
        3308
    ],
    "jahanque": [
        3308
    ],
    "jahonque": [
        3308
    ],
    "jakankalou": [
        3308
    ],
    "jaxanka": [
        3308
    ],
    "jabem": [
        3309
    ],
    "jabim": [
        3309
    ],
    "jabêm": [
        3309
    ],
    "jara": [
        3310
    ],
    "jera": [
        3310,
        3352
    ],
    "jah hut": [
        3311
    ],
    "jah": [
        3311
    ],
    "jah het": [
        3311
    ],
    "jajao": [
        3312
    ],
    "jakun": [
        3313,
        3386
    ],
    "jakoon": [
        3313
    ],
    "jakud’n": [
        3313
    ],
    "jaku’d": [
        3313
    ],
    "jahalatan": [
        3314
    ],
    "jahalatane": [
        3314
    ],
    "jamaican english creole": [
        3315
    ],
    "jamaican": [
        3315,
        3388,
        3336
    ],
    "jamaican creole english": [
        3315
    ],
    "jamaican patois": [
        3315
    ],
    "jamiekan": [
        3315
    ],
    "jimiekn": [
        3315
    ],
    "jimiekn langwij": [
        3315
    ],
    "jumieka kruyol": [
        3315
    ],
    "jumieka": [
        3315
    ],
    "jumieka languij": [
        3315
    ],
    "jumieka langwij": [
        3315
    ],
    "jumieka taak": [
        3315
    ],
    "jumiekan": [
        3315
    ],
    "jumiekan kriol": [
        3315
    ],
    "jumiekan languij": [
        3315
    ],
    "jandai": [
        3316
    ],
    "janday": [
        3316
    ],
    "jendairwal": [
        3316
    ],
    "jundai": [
        3316
    ],
    "janjula": [
        3317
    ],
    "jakai": [
        3318
    ],
    "jaqai": [
        3318
    ],
    "javanese, new caledonian": [
        3319
    ],
    "javanese": [
        3319,
        3444,
        3445,
        3447
    ],
    "jakati": [
        3320
    ],
    "jat": [
        3320,
        3340
    ],
    "jataki": [
        3320
    ],
    "jaur": [
        3321
    ],
    "jambi": [
        3322
    ],
    "jambi malay": [
        3322
    ],
    "jarnango": [
        3323
    ],
    "jawe": [
        3324
    ],
    "judeo-berber": [
        3325
    ],
    "jaban": [
        3327
    ],
    "jabal nafusi": [
        3330
    ],
    "jabal": [
        3330,
        6649
    ],
    "jbel nafusi": [
        3330
    ],
    "jbel": [
        3330
    ],
    "jebel nefusi": [
        3330
    ],
    "jebel": [
        3330,
        7033
    ],
    "jofotek-bromnya": [
        3332
    ],
    "jabutí": [
        3333
    ],
    "jabotí": [
        3333
    ],
    "jeoromitxí": [
        3333
    ],
    "jukun takum": [
        3334
    ],
    "jadjiba": [
        3335
    ],
    "jadjibaia": [
        3335
    ],
    "jaudji-bara": [
        3335
    ],
    "jaudjibaia": [
        3335
    ],
    "jaudjibara": [
        3335
    ],
    "jawadjag": [
        3335
    ],
    "jawdjibaia": [
        3335
    ],
    "jawdjibara": [
        3335
    ],
    "jawdjobara": [
        3335
    ],
    "jawutjubar": [
        3335
    ],
    "jamaican country sign language": [
        3336
    ],
    "judeo-crimean tatar": [
        3337,
        3338
    ],
    "judeo-crimean": [
        3337,
        3338
    ],
    "judeo-crimean turkish": [
        3337,
        3338
    ],
    "jad": [
        3339
    ],
    "jadgali": [
        3340
    ],
    "jatgali": [
        3340
    ],
    "jatki": [
        3340
    ],
    "judeo-tat": [
        3341,
        3342,
        3343
    ],
    "jewish tat": [
        3341,
        3342,
        3343
    ],
    "judeo-tatic": [
        3341,
        3342,
        3343
    ],
    "juhur": [
        3341,
        3342,
        3343
    ],
    "juhuri": [
        3341,
        3342,
        3343
    ],
    "juwri": [
        3341,
        3342,
        3343
    ],
    "jebero": [
        3344
    ],
    "jerung": [
        3345
    ],
    "jero mala": [
        3345
    ],
    "jerum": [
        3345
    ],
    "jerunge": [
        3345
    ],
    "jherung": [
        3345
    ],
    "jeh": [
        3346,
        3347
    ],
    "jei": [
        3348
    ],
    "jeri kuo": [
        3349
    ],
    "jeri": [
        3349
    ],
    "jeli kuo": [
        3349
    ],
    "jeli": [
        3349
    ],
    "jab": [
        3350,
        7531
    ],
    "jabsch": [
        3350
    ],
    "jelmek": [
        3350
    ],
    "jelmik": [
        3350
    ],
    "ja": [
        3351,
        5952
    ],
    "janjo": [
        3351
    ],
    "jen": [
        3351,
        8675
    ],
    "jenjo": [
        3351
    ],
    "jere": [
        3352
    ],
    "jeere": [
        3352
    ],
    "jeti": [
        3353
    ],
    "jonkor bourmataguil": [
        3354
    ],
    "jonkor": [
        3354,
        4924
    ],
    "judeo-georgian": [
        3356,
        3357
    ],
    "jaracin kasa": [
        3358
    ],
    "jaracin": [
        3358
    ],
    "jaranchi": [
        3358,
        3379
    ],
    "jaranci": [
        3358,
        3379
    ],
    "jarancin kasa": [
        3358,
        3379
    ],
    "jarancin": [
        3358,
        3379
    ],
    "jarawan bununu": [
        3358
    ],
    "jarawan kasa": [
        3358,
        3379
    ],
    "jehai": [
        3360
    ],
    "jahai": [
        3360
    ],
    "jhankot sign language": [
        3361
    ],
    "jhankot": [
        3361
    ],
    "jina": [
        3362
    ],
    "jibanci": [
        3363
    ],
    "jibawa": [
        3363
    ],
    "jida": [
        3365
    ],
    "jida-abu": [
        3365
    ],
    "jidda-abu": [
        3365
    ],
    "jilbe": [
        3366
    ],
    "jingulu": [
        3367
    ],
    "jingali": [
        3367
    ],
    "jingili": [
        3367
    ],
    "jiiddu": [
        3369
    ],
    "jiddu": [
        3369
    ],
    "jilim": [
        3370
    ],
    "jimjimen": [
        3371
    ],
    "jimi (cameroon)": [
        3371
    ],
    "jimjimən": [
        3371
    ],
    "jiamao": [
        3372
    ],
    "jita": [
        3374
    ],
    "jinuo, youle": [
        3375
    ],
    "jinuo": [
        3375,
        3377
    ],
    "jino": [
        3375,
        3377
    ],
    "jinuo, buyuan": [
        3377
    ],
    "jejueo": [
        3378
    ],
    "jeju": [
        3378
    ],
    "jeju bang-eon": [
        3378
    ],
    "jeju saturi": [
        3378
    ],
    "jejumal": [
        3378
    ],
    "jaaku": [
        3386
    ],
    "jakanci": [
        3386
    ],
    "jamaican sign language": [
        3388
    ],
    "jsl": [
        3388,
        3425
    ],
    "jamaica sign language": [
        3388
    ],
    "jimajima": [
        3389
    ],
    "jimjam": [
        3389
    ],
    "jimbin": [
        3390
    ],
    "jimbinawa": [
        3390
    ],
    "jamden": [
        3392
    ],
    "jamdena": [
        3392
    ],
    "jimi (nigeria)": [
        3393
    ],
    "jumli": [
        3394
    ],
    "jumla": [
        3439,
        3394
    ],
    "jumleli": [
        3394
    ],
    "juxtlahuaca": [
        3399,
        8106,
        4815
    ],
    "jangshung": [
        3400
    ],
    "jangiam": [
        3400
    ],
    "jangrami": [
        3400
    ],
    "jandavra": [
        3401
    ],
    "jhandoria": [
        3401
    ],
    "jangman": [
        3402
    ],
    "jongman": [
        3402
    ],
    "jungman": [
        3402
    ],
    "janji": [
        3403
    ],
    "jenji": [
        3403
    ],
    "jangali": [
        3406
    ],
    "janggali": [
        3406,
        6530
    ],
    "jhangar": [
        3406
    ],
    "jaunsari": [
        3407,
        3408,
        3409
    ],
    "jansauri": [
        3407,
        3408,
        3409
    ],
    "jaunpuri": [
        3407,
        3408,
        3409
    ],
    "jaunsauri": [
        3407,
        3408,
        3409
    ],
    "joba": [
        3410
    ],
    "jogi": [
        3412
    ],
    "jorá": [
        3413
    ],
    "jordanian sign language": [
        3414
    ],
    "jordanian": [
        3414
    ],
    "jowulu": [
        3415
    ],
    "jewish palestinian aramaic": [
        3416
    ],
    "judeo-persian": [
        3417
    ],
    "judi": [
        3417
    ],
    "jaqaru": [
        3418
    ],
    "jacaru": [
        3418
    ],
    "jaq’aru": [
        3418
    ],
    "jarai": [
        3419,
        3420
    ],
    "jơrai": [
        3419,
        3420
    ],
    "jo’rai": [
        3419,
        3420
    ],
    "judeo-arabic": [
        3421,
        3450,
        8791,
        8922
    ],
    "jiru": [
        3422
    ],
    "jakattoe": [
        3423
    ],
    "jakato": [
        3423
    ],
    "jorto": [
        3423
    ],
    "japreria": [
        3424
    ],
    "japrería": [
        3424,
        8935
    ],
    "japanese sign language": [
        3425
    ],
    "júma": [
        3426
    ],
    "jukun abinsi": [
        3427
    ],
    "jurchen": [
        3428
    ],
    "jinkum": [
        3432
    ],
    "jukon": [
        3432
    ],
    "juku": [
        3432
    ],
    "juku junkun": [
        3432
    ],
    "junkun": [
        3432
    ],
    "jukum": [
        3432
    ],
    "jukun wapan": [
        3432
    ],
    "jukun wukari": [
        3432
    ],
    "jirel": [
        3433
    ],
    "jiri": [
        3433
    ],
    "jirial": [
        3433
    ],
    "jumjum": [
        3434
    ],
    "jiik mäbaan": [
        3434
    ],
    "jiik": [
        3434
    ],
    "juang": [
        3435
    ],
    "juango": [
        3435
    ],
    "jiba": [
        3436
    ],
    "jibe": [
        3436
    ],
    "jibi": [
        3436
    ],
    "jibə": [
        3436
    ],
    "jukun kona": [
        3436
    ],
    "jupde": [
        3437
    ],
    "jurúna": [
        3438
    ],
    "jaruna": [
        3438
    ],
    "jurûna": [
        3438
    ],
    "jumla sign language": [
        3439
    ],
    "jutish": [
        3440
    ],
    "ju": [
        3441,
        5266
    ],
    "jukun wase": [
        3442
    ],
    "juray": [
        3443
    ],
    "jawa": [
        3444,
        3447,
        3445
    ],
    "javindo": [
        3446
    ],
    "javanese, suriname": [
        3447
    ],
    "jawa suriname": [
        3447
    ],
    "javaans": [
        3447
    ],
    "jwira-pepesa": [
        3448
    ],
    "jarong": [
        3449
    ],
    "jyarung": [
        3449
    ],
    "judeo-yemeni": [
        3450
    ],
    "judeo-yemeni arabic": [
        3450
    ],
    "jaya": [
        3451
    ],
    "jingpho": [
        3461
    ],
    "jinghpaw": [
        3461
    ],
    "jinghpo": [
        3461
    ],
    "jingphaw": [
        3461,
        6820
    ],
    "jingpo": [
        3461
    ],
    "jju": [
        3468
    ],
    "jutaí": [
        3474
    ],
    "jangkundjara": [
        3534
    ],
    "jirru": [
        3564
    ],
    "jon kule": [
        3739,
        3740
    ],
    "jon": [
        3739,
        3740
    ],
    "juruá": [
        3840
    ],
    "jafoo": [
        3893
    ],
    "jola-karone": [
        3947
    ],
    "juǀ’hoansi": [
        4006
    ],
    "juǀʼhoan": [
        4006
    ],
    "juǀʼhoansi": [
        4006
    ],
    "juǀ’hoan": [
        4006
    ],
    "ju’oasi": [
        4006
    ],
    "jori": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "jorîn": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "jau-navo": [
        4032
    ],
    "juanauo": [
        4032
    ],
    "jatapu": [
        4123,
        4124
    ],
    "jach-t'aan": [
        4188
    ],
    "jach-t’aan": [
        4188
    ],
    "jidió": [
        4189,
        4190,
        4191
    ],
    "jidyo": [
        4189,
        4190,
        4191
    ],
    "judeo spanish": [
        4189,
        4190,
        4191
    ],
    "judeo": [
        4189,
        4190,
        4191
    ],
    "judeo-espagnol": [
        4189,
        4190,
        4191
    ],
    "judeo-espaniol": [
        4189,
        4190,
        4191
    ],
    "judeo-espanýol": [
        4189,
        4190,
        4191
    ],
    "judeo-español": [
        4189,
        4190,
        4191
    ],
    "judeo-spanish": [
        4189
    ],
    "judesmo": [
        4189,
        4190,
        4191
    ],
    "judezmo": [
        4189,
        4190,
        4191
    ],
    "judyo": [
        4189,
        4190,
        4191
    ],
    "judío": [
        4189,
        4190,
        4191
    ],
    "jūdeo-esupanyōru": [
        4189,
        4190,
        4191
    ],
    "jangli": [
        4196,
        4197,
        4198,
        4200
    ],
    "jru": [
        4231
    ],
    "jruq": [
        4231
    ],
    "jru’": [
        4231
    ],
    "jaba duya": [
        4253
    ],
    "jaba lunga": [
        4253
    ],
    "jogo": [
        4331
    ],
    "jirandali": [
        4355
    ],
    "juru": [
        4356
    ],
    "jo-pari": [
        4369
    ],
    "jengjeng": [
        4428
    ],
    "jonubi": [
        4541
    ],
    "jo lwo": [
        4554
    ],
    "jur luo": [
        4554
    ],
    "jur luwo": [
        4554
    ],
    "jur lwo": [
        4554
    ],
    "jerónimo": [
        4571
    ],
    "jalapa": [
        4581
    ],
    "jalapa de díaz mazatec": [
        4581
    ],
    "jimenez": [
        4594
    ],
    "jnatrjo": [
        4599
    ],
    "jitnu": [
        4612
    ],
    "jù bà": [
        4645
    ],
    "jù": [
        4645
    ],
    "juli": [
        4645
    ],
    "jawi-malay": [
        4707,
        4708
    ],
    "jifelm": [
        4726
    ],
    "jili": [
        4748
    ],
    "jaako": [
        4773
    ],
    "jamiltepec-chayuco": [
        4799
    ],
    "jicaltepec mixtec": [
        4807
    ],
    "jicaltepec": [
        4807
    ],
    "jamiltepec": [
        5224,
        4807,
        8113
    ],
    "jim mun": [
        4824
    ],
    "jim": [
        4824
    ],
    "jinmen": [
        4824
    ],
    "jnatjo": [
        4901
    ],
    "jongor": [
        4924
    ],
    "jonggunu": [
        4959
    ],
    "jonkor-gera": [
        4983
    ],
    "jigalong": [
        4993
    ],
    "janggu": [
        5044
    ],
    "jhoria": [
        5143
    ],
    "jaiselmer": [
        5153,
        5154
    ],
    "juwar": [
        5176
    ],
    "juwal": [
        5176
    ],
    "jaipuri": [
        5190
    ],
    "jhar-sahi boli": [
        5190
    ],
    "jhar-sahi": [
        5190
    ],
    "juquila": [
        5221
    ],
    "juquila mixe": [
        5221
    ],
    "jamiltepec-san": [
        5224
    ],
    "jamiltepec mixtec": [
        5224
    ],
    "jepa-matsi": [
        5253
    ],
    "jejea": [
        5253
    ],
    "ju nɔri": [
        5266
    ],
    "janela": [
        5278
    ],
    "jan": [
        5309
    ],
    "jahadian": [
        5404
    ],
    "jeng": [
        5493
    ],
    "jenge": [
        5493
    ],
    "jaipuria": [
        5494
    ],
    "jumiaki": [
        5548
    ],
    "jaly": [
        5550
    ],
    "jalè": [
        5550
    ],
    "joboka": [
        5606,
        5607,
        5608
    ],
    "jokoba": [
        5606,
        5607,
        5608
    ],
    "jang-kala": [
        5615
    ],
    "janga": [
        5615
    ],
    "jangaa": [
        5615
    ],
    "jangga": [
        5615
    ],
    "jale": [
        5648
    ],
    "jèrriais": [
        5667
    ],
    "jersey french": [
        5667
    ],
    "jersey norman": [
        5667
    ],
    "juanga": [
        5725
    ],
    "jilngali": [
        5730
    ],
    "jibwemwin": [
        5859,
        5860
    ],
    "java": [
        5867,
        6725
    ],
    "junoi": [
        5879
    ],
    "juwai": [
        5879
    ],
    "juwoi": [
        5879
    ],
    "janbeba": [
        5907
    ],
    "jauareta-tapiia": [
        6022,
        8240
    ],
    "juba arabic": [
        6111
    ],
    "juba": [
        6111
    ],
    "jabura": [
        6150
    ],
    "jiongnai": [
        6244
    ],
    "jiongnai bunu": [
        6244
    ],
    "jiongnaihua": [
        6244
    ],
    "jaspuy pai": [
        6269
    ],
    "jaspuy": [
        6269
    ],
    "jo’é": [
        6345
    ],
    "jejara": [
        6392
    ],
    "junín": [
        6423
    ],
    "junín quechua": [
        6423
    ],
    "jauja": [
        6448
    ],
    "jauja wanca quechua": [
        6448
    ],
    "jigong": [
        6481
    ],
    "jang": [
        6497,
        6498
    ],
    "johari": [
        6508
    ],
    "jawhumjeri": [
        6538
    ],
    "jib": [
        6544
    ],
    "jabal razih": [
        6649
    ],
    "jelkung": [
        6658
    ],
    "java jati": [
        6725
    ],
    "jharkhandhi": [
        6726,
        6727
    ],
    "judeo-comtadine": [
        6766
    ],
    "judeo-provençal": [
        6766
    ],
    "jaun-jaun": [
        6809
    ],
    "jobikha": [
        6823
    ],
    "jibali": [
        6857
    ],
    "jibbali": [
        6857
    ],
    "jama mapun": [
        6896
    ],
    "jbala": [
        6906
    ],
    "julevusámegiella": [
        6970
    ],
    "jaggoi": [
        6993
    ],
    "jagoi": [
        6993
    ],
    "jebel silak": [
        7033
    ],
    "jebels sillok": [
        7033
    ],
    "jebels": [
        7033
    ],
    "jungle spanish": [
        7061
    ],
    "juna": [
        7321
    ],
    "jʉna ye": [
        7321
    ],
    "jʉna": [
        7321
    ],
    "jemu": [
        7392
    ],
    "jabaal": [
        7420
    ],
    "jo thuri": [
        7485
    ],
    "joole manga": [
        7490
    ],
    "joole": [
        7490
    ],
    "jurruru": [
        7530
    ],
    "jururu": [
        7530
    ],
    "jab wurrong": [
        7531
    ],
    "jab wurrung": [
        7531
    ],
    "jomang": [
        7575
    ],
    "jewish babylonian aramaic": [
        7605
    ],
    "jewish babylonian aramaic (ca. 200-1200 ce)": [
        7605
    ],
    "jakari": [
        7624
    ],
    "juárez": [
        7649,
        8969
    ],
    "jemez": [
        7656
    ],
    "jemez towa": [
        7656
    ],
    "joloano": [
        7734,
        7735
    ],
    "joloano sulu": [
        7734,
        7735
    ],
    "jolohano": [
        7734,
        7735
    ],
    "jotafa": [
        7763
    ],
    "jayapura": [
        7763
    ],
    "jäāk tpür": [
        7791
    ],
    "jäāk": [
        7791
    ],
    "jäāk tüpür": [
        7791
    ],
    "jäāk tüpürï": [
        7791
    ],
    "jarjar": [
        7849
    ],
    "jijili": [
        7930
    ],
    "jintjingga": [
        7959,
        7960
    ],
    "je’ẽha": [
        7993
    ],
    "jupaú": [
        8013
    ],
    "jango": [
        8075
    ],
    "jing": [
        8078,
        8079,
        8080
    ],
    "juxtlahuaca mixtec": [
        8106
    ],
    "jnu’u lavi": [
        8116
    ],
    "jnu’u": [
        8116
    ],
    "jafi": [
        8216
    ],
    "jafi wagarindem": [
        8216
    ],
    "jilbara": [
        8222
    ],
    "jiwaka": [
        8225
    ],
    "jojod": [
        8322
    ],
    "jeidji": [
        8361
    ],
    "jeithi": [
        8361
    ],
    "jiangnan": [
        8369,
        8370,
        8371
    ],
    "jiangsu-zhejiang": [
        8369,
        8370,
        8371
    ],
    "jiangzhe": [
        8369,
        8370,
        8371
    ],
    "jiāngdōng huà": [
        8369,
        8370,
        8371
    ],
    "jiāngdōng": [
        8369,
        8370,
        8371
    ],
    "jabaru": [
        8381
    ],
    "jacareúba": [
        8407
    ],
    "jinca": [
        8485
    ],
    "jaitmatang": [
        8491
    ],
    "jadjmadang": [
        8491
    ],
    "jaithmathang": [
        8491
    ],
    "jaitmathang": [
        8491
    ],
    "jaburu": [
        8562
    ],
    "jana": [
        8571
    ],
    "janari": [
        8571
    ],
    "jauna": [
        8571
    ],
    "jidajida": [
        8651
    ],
    "jennu": [
        8675
    ],
    "jen kurumba": [
        8675
    ],
    "jennu kurumba": [
        8675
    ],
    "jennu nudi": [
        8675
    ],
    "juadjag": [
        8695
    ],
    "juadjuk": [
        8695
    ],
    "jambajamba": [
        8701
    ],
    "jupa-galk-wournditch": [
        8701
    ],
    "jeigir": [
        8707
    ],
    "jungai": [
        8707
    ],
    "jotijota": [
        8713
    ],
    "jaminawa": [
        8717
    ],
    "jalonke": [
        8729,
        8730
    ],
    "jalonké": [
        8729,
        8730
    ],
    "jalunga": [
        8730,
        8729
    ],
    "jalunga xuwiina’": [
        8729,
        8730
    ],
    "jalunganéé": [
        8729,
        8730
    ],
    "jalungas": [
        8729,
        8730
    ],
    "jalunga xuwiina'": [
        8730
    ],
    "jao": [
        8733,
        8734
    ],
    "jodï": [
        8740
    ],
    "joti": [
        8740
    ],
    "jaulapiti": [
        8742
    ],
    "jimi bhasa": [
        8750
    ],
    "jabaana": [
        8756
    ],
    "jabâ-ana": [
        8756
    ],
    "janda": [
        8764
    ],
    "jenisch": [
        8770
    ],
    "judeo-greek": [
        8773
    ],
    "jiantouyi": [
        8785
    ],
    "judeo-iraqi": [
        8791
    ],
    "jewish iraqi-baghdadi arabic": [
        8791
    ],
    "judeo-iraqi arabic": [
        8791
    ],
    "jiantou phula": [
        8792
    ],
    "jiantou": [
        8792,
        8801
    ],
    "judeo-german": [
        8794,
        8798
    ],
    "jinggarda": [
        8795
    ],
    "jidindji": [
        8799
    ],
    "jindjibandi": [
        8800
    ],
    "jindjibarndi": [
        8800
    ],
    "jukagir": [
        8816,
        8940
    ],
    "jauke": [
        8817
    ],
    "jalanga": [
        8836
    ],
    "jaloc": [
        8837
    ],
    "jaúna": [
        8868
    ],
    "jui": [
        8882
    ],
    "jawari": [
        8899
    ],
    "jeljendi": [
        8902
    ],
    "jeljujendi": [
        8902
    ],
    "jugumbir": [
        8920
    ],
    "jukamba": [
        8920
    ],
    "judeo-tripolitanian": [
        8922
    ],
    "jewish tripolitanian-libyan arabic": [
        8922
    ],
    "judeo-tripolitanian arabic": [
        8922
    ],
    "jug": [
        8928
    ],
    "juriti": [
        8929
    ],
    "juriti-tapuia": [
        8929
    ],
    "jurití": [
        8929
    ],
    "juruti": [
        8929
    ],
    "juruti-tapuia": [
        8929
    ],
    "jawanaua": [
        8948
    ],
    "jagara": [
        8956
    ],
    "jagarabal": [
        8956
    ],
    "jagera": [
        8956
    ],
    "jergarbal": [
        8956
    ],
    "jinibara": [
        8956
    ],
    "jadliaura": [
        8957
    ],
    "jadlijawara": [
        8957
    ],
    "jadloori": [
        8957
    ],
    "jinwum": [
        8958
    ],
    "jeraruk": [
        8959
    ],
    "jirau": [
        8959
    ],
    "juju": [
        8959
    ],
    "jabalajabala": [
        8960
    ],
    "jabulajabula": [
        8960
    ],
    "jir joront": [
        8961
    ],
    "jir": [
        8961
    ],
    "joront": [
        8961
    ],
    "jirjiront": [
        8961
    ],
    "jir’jorond": [
        8961
    ],
    "juárez zapotec": [
        8969
    ],
    "jaojo": [
        8981
    ],
    "juchitán zapotec": [
        8984
    ],
    "juchitán": [
        8984
    ],
    "jegan": [
        8998
    ],
    "jabji": [
        9046
    ],
    "jinja": [
        9056
    ],
    "jilbu": [
        9058
    ],
    "jilvu": [
        9058
    ],
    "jaitjawarra": [
        9071
    ],
    "jou": [
        9115
    ],
    "jalpan": [
        9170
    ],
    "jingxi zhuang": [
        9181
    ],
    "jingxi": [
        9181
    ]
};
